var map = {
	"./arrow-list.svg": 1401,
	"./arrow_mobile.svg": 7743,
	"./cordova.svg": 2417,
	"./figma.svg": 6590,
	"./figma_logo.svg": 6025,
	"./jquery.svg": 30,
	"./nuxt.svg": 4120,
	"./python.svg": 4426,
	"./vue.svg": 4929,
	"./yii.svg": 5339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2242;